import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bottom-navigation-mobile/bar-top-active.webp")